class MandatePayroll {
  status: string;
  fromAccount: string;
  username: string;
  userId: string;
  postingDate: string;
  amount: string;
  currency: string;
  referenceNumber: string;
  beneficiaryName: string;
  accountId: number;
  orderDirection: string;
  globalOrderId: number;
  orderMessageType: string;
  accountNumber: string;
  customerId: number;
  orderProcessType: string;
  processStatus: string;
  fileType: string;
  fileName: string;
  payrollFileId: string;

  constructor(
    status: string,
    fromAccount: string,
    username: string,
    userId: string,
    postingDate: string,
    amount: string,
    currency: string,
    referenceNumber: string,
    beneficiaryName: string,
    accountId: number,
    orderDirection: string,
    globalOrderId: number,
    orderMessageType: string,
    accountNumber: string,
    customerId: number,
    orderProcessType: string,
    processStatus: string,
    fileType: string,
    fileName: string,
    payrollFileId: string,
  ) {
    this.status = status;
    this.fromAccount = fromAccount;
    this.username = username;
    this.userId = userId;
    this.postingDate = postingDate;
    this.amount = amount;
    this.currency = currency;
    this.referenceNumber = referenceNumber;
    this.beneficiaryName = beneficiaryName;
    this.accountId = accountId;
    this.orderDirection = orderDirection;
    this.globalOrderId = globalOrderId;
    this.orderMessageType = orderMessageType;
    this.accountNumber = accountNumber;
    this.customerId = customerId;
    this.orderProcessType = orderProcessType;
    this.processStatus = processStatus;
    this.fileType = fileType;
    this.fileName = fileName;
    this.payrollFileId = payrollFileId;
  }
}

export default MandatePayroll;
